import { TableColumnType } from 'src/types/table';

export const attemptColumns: TableColumnType[] = [
    {
        key: 'ATTEMPT',
        label: 'attempt',
        type: 'number',
        defaultShow: true,
        allwaysShow: true,
    },
    {
        key: 'SENDING_TIME',
        label: 'sendingTime',
        type: 'dateTime',
        defaultShow: true,
        allwaysShow: true,
    },
    {
        key: 'STATUS_CODE',
        label: 'statusCode',
        type: 'number',
        defaultShow: true,
        allwaysShow: true,
        customRender: true,
    },
];
